import { app } from '../../../../../app';
import { Controller } from './send-verification-email.controller';

app.component('companyUserDirectoriesManageAccountSendVerificationEmail', {
    bindings: {
        account: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./send-verification-email.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/send-verification-email/send-verification-email.component.js